import { ADOBE_DATA_LAYER_URL } from "../config/urls";
import { getSettings } from "../helpers/get-settings";
import { getCandidateData } from "./candidate-data";

interface MetricsWindow {
  dataLayerArray?: any[];
}

const WORKFLOW = "BB NACF Tier-1 Node Workflow";

getSettings().then((settings) => {
  const script = document.createElement("script");
  script.setAttribute("src", ADOBE_DATA_LAYER_URL[settings.stage]);
  script.setAttribute("defer", "");
  script.setAttribute("async", "");
  document.body.appendChild(script);
});

const pushLayer = (window: MetricsWindow, metric: any) => {
  if (process.env.NODE_ENV === "development") {
    console.log(metric);
  }
  window.dataLayerArray = window.dataLayerArray || [];
  window.dataLayerArray.push(metric);
};

export async function addPageLoadMetric(
  window: MetricsWindow,
  applicationId: string,
  name: string,
  props?: any
) {
  const { sfCandidateId } = await getCandidateData(applicationId);
  const metric = {
    application: {
      ID: applicationId,
      workflow: WORKFLOW,
    },
    event: "page load",
    candidate: {
      CID: sfCandidateId,
    },
    page: {
      name: name,
      type: "application",
    },
    ...props,
  };

  pushLayer(window, metric);
}

export async function addEventMetric(
  window: MetricsWindow,
  applicationId: string,
  event: string,
  props?: any
) {
  const { sfCandidateId } = await getCandidateData(applicationId);
  const metric = {
    application: {
      ID: applicationId,
      workflow: WORKFLOW,
    },
    event: event,
    candidate: {
      CID: sfCandidateId,
    },
    ...props,
  };

  pushLayer(window, metric);
}

function isAshReferral(domain: string) {
  return [
    "localhost",
    "checklist.associate.amazondelivers.jobs",
    "iad.checklist.associate.amazondelivers.jobs",
    "gamma.iad.checklist.associate.amazondelivers.jobs",
    "beta.pdx.checklist.associate.amazondelivers.jobs",
    "alpha.pdx.checklist.associate.amazondelivers.jobs",
  ].includes(domain);
}

function isBBReferral(domain: string) {
  return [
    "alpha.associate.amazondelivers.jobs",
    "beta.associate.amazondelivers.jobs",
    "gamma.associate.amazondelivers.jobs",
    "associate.amazondelivers.jobs",
  ].includes(domain);
}

export function interpretReferrer(referrer: string) {
  if (window.ASH_CHECKLIST_isChecklistReferral) {
    return "videoASHChecklistReferral";
  }

  if (!referrer) {
    return "videoEmailReferral";
  }

  const referrerHost = new URL(referrer).hostname;
  if (isAshReferral(referrerHost)) {
    return "videoAshChecklistReferral";
  }

  if (isBBReferral(referrerHost)) {
    return "videoBBChecklistReferral";
  }

  return "unknownReferral - " + referrerHost;
}
